/* ============================================================
   LEWD FASHION — "Level Up Your Lewk" Cart Drawer  v1
   Asset: assets/lf-cart-drawer.js

   Full replacement for the Monster Cart app.
   - Intercepts every /cart/add form site-wide (capture phase)
   - Suppresses Dawn's native cart notification/drawer
   - XP bar with 3 reward tiers: FREE SHIP ($150 US/CA, $250 elsewhere),
     FREE GIFT ($200), 20% OFF ($300) — order varies by market, see below
   - Smart gap nudge (suggests a real product to hit next level)
   - Free-gift picker once the gift tier is reached (line property _lf_gift)
   - "Rare Drops" upsell slots w/ rarity stamps
   - Add-on toggle pills (discreet shipping, pasties)
   - Coupon code -> /checkout?discount=CODE
   - Confetti + stamp slam + toast on level-up
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.LF_CART_CONFIG || { tiers: [], currency: '$' };
  var TIERS = CFG.tiers;
  var MAX_TIER = TIERS.length ? TIERS[TIERS.length - 1].amount : 0;

  function pool(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  var DROPS = pool('lf-pool-drops');
  var GIFTS = pool('lf-pool-gifts');
  var ADDONS = pool('lf-pool-addons');
  var GIFT_HANDLES = GIFTS.map(function (g) { return g.handle; });
  var ADDON_HANDLES = ADDONS.map(function (a) { return a.handle; });
  var ADDON_SKIP = CFG.nonProduct || [];
  /* colour words → the add-on colour families */
  var COLOURS = [
    ['pink', ['pink', 'rose', 'peach', 'bubblegum', 'blush', 'fuchsia', 'magenta']],
    ['white', ['white', 'ivory', 'cream', 'beige', 'silver', 'pearl', 'bridal']],
    ['blue', ['blue', 'indigo', 'turquoise', 'denim', 'navy', 'teal', 'aqua', 'cyan']],
    ['red', ['red', 'cherry', 'crimson', 'scarlet']],
    ['purple', ['purple', 'lavender', 'violet', 'lilac']],
    ['yellow', ['yellow']],
    ['black', ['black']]
  ];
  function colourOf(s) {
    s = String(s || '').toLowerCase();
    var best = null, pos = Infinity;
    COLOURS.forEach(function (c) {
      c[1].forEach(function (w) {
        var m = s.search(new RegExp('(^|[^a-z])' + w + '([^a-z]|$)'));
        if (m !== -1 && m < pos) { pos = m; best = c[0]; }
      });
    });
    return best;
  }

  var $ = function (sel) { return document.querySelector(sel); };
  /* shared formatter (assets/lf-util.js) so the drawer + bundle section format
     prices identically; inline fallback keeps the drawer working if it's absent */
  var money = function (cents) {
    if (window.LFUtil && typeof window.LFUtil.money === 'function') return window.LFUtil.money(cents);
    return CFG.currency + (cents / 100).toFixed(2);
  };

  var LFCart = {
    cart: null,
    prevLevel: -1,
    pickedGiftId: GIFTS.length ? GIFTS[0].id : null,
    coupon: '',
    busy: false,
    opened: false,

    /* ---------------- core ---------------- */
    init: function () {
      this.bindShell();
      this.interceptATC();
      this.interceptCartLinks();
      this.refresh(false);
    },

    fetchCart: function () {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    },

    refresh: function (openAfter) {
      var self = this;
      return this.fetchCart().then(function (cart) {
        self.cart = cart;
        self.syncGiftLine().then(function () {
          self.render();
          if (openAfter) self.open();
        });
      });
    },

    /* tier math excludes the free gift line */
    giftLine: function () {
      if (!this.cart) return null;
      return this.cart.items.find(function (it) {
        return it.properties && it.properties._lf_gift;
      }) || null;
    },
    tierSubtotal: function () {
      if (!this.cart) return 0;
      var g = this.giftLine();
      return this.cart.items_subtotal_price - (g ? g.final_line_price : 0);
    },
    level: function () {
      var s = this.tierSubtotal(), lvl = 0;
      TIERS.forEach(function (t) { if (s >= t.amount) lvl++; });
      return lvl;
    },

    /* Look rewards up by key, never by ordinal level. The free-shipping
       threshold is $150 in the US/Canada and $250 everywhere else, so the tier
       ORDER differs by market (internationally FREE GIFT is LVL 1, FREE SHIP is
       LVL 2). LVL numbers stay correct for display because the Liquid config
       emits the tiers already sorted ascending — but "is the gift unlocked" is
       a question about the gift tier's own amount, not about a level number. */
    tierByKey: function (key) {
      for (var i = 0; i < TIERS.length; i++) if (TIERS[i].key === key) return TIERS[i];
      return null;
    },
    reached: function (key) {
      var t = this.tierByKey(key);
      return !!t && this.tierSubtotal() >= t.amount;
    },

    /* auto-add picked gift once the gift tier is reached, auto-remove below */
    syncGiftLine: function () {
      var self = this;
      var g = this.giftLine();
      var giftUnlocked = this.reached('gift');
      if (giftUnlocked && !g && this.pickedGiftId) {
        return this.post('/cart/add.js', {
          items: [{ id: this.pickedGiftId, quantity: 1, properties: { _lf_gift: 'true' } }]
        }).then(function () { return self.fetchCart(); })
          .then(function (c) { self.cart = c; });
      }
      if (!giftUnlocked && g) {
        return this.post('/cart/change.js', { id: g.key, quantity: 0 })
          .then(function (c) { self.cart = c; self.toast('drop lost — level back up to re-equip ♡'); });
      }
      return Promise.resolve();
    },

    swapGift: function (variantId) {
      var self = this;
      this.pickedGiftId = variantId;
      var g = this.giftLine();
      var chain = Promise.resolve();
      if (g && g.variant_id !== variantId) {
        chain = this.post('/cart/change.js', { id: g.key, quantity: 0 });
      }
      chain.then(function () { self.refresh(false); });
    },

    post: function (url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },

    addVariant: function (variantId, props) {
      var self = this;
      if (this.busy) return; this.busy = true;
      this.post('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props || {} }] })
        .then(function () { self.busy = false; self.refresh(true); self.toast('added to ur fit ✦'); })
        .catch(function () { self.busy = false; self.toast('couldn’t add that — try again'); });
    },

    changeQty: function (lineKey, qty) {
      var self = this;
      if (this.busy) return; this.busy = true;
      this.post('/cart/change.js', { id: lineKey, quantity: qty })
        .then(function (c) { self.cart = c; self.busy = false; return self.syncGiftLine(); })
        .then(function () { self.render(); })
        .catch(function () { self.busy = false; });
    },

    /* ---------------- ATC interception ---------------- */
    interceptATC: function () {
      var self = this;
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!(f instanceof HTMLFormElement)) return;
        var action = f.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;
        e.preventDefault();
        e.stopPropagation();
        var fd = new FormData(f);
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd })
          .then(function (r) {
            if (!r.ok) throw new Error('atc');
            return r.json();
          })
          .then(function () { self.refresh(true); self.toast('added to ur fit ✦'); })
          .catch(function () { self.toast('couldn’t add that — check ur size'); });
      }, true); /* capture phase beats Dawn's product-form listener */

      /* kill Dawn's cart-notification custom event if it fires anyway */
      ['cart:open', 'cart-drawer:open'].forEach(function (evt) {
        document.addEventListener(evt, function (e) { e.stopImmediatePropagation(); }, true);
      });
    },

    /* header cart icon + any /cart link opens the drawer */
    interceptCartLinks: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href="/cart"], a[href$="/cart"], .header__icon--cart');
        if (!a) return;
        e.preventDefault();
        e.stopPropagation();
        self.refresh(true);
      }, true);
    },

    /* ---------------- shell ---------------- */
    bindShell: function () {
      var self = this;
      $('#lfc-close').addEventListener('click', function () { self.close(); });
      $('#lf-cart-overlay').addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
      document.querySelectorAll('[data-lfc-continue]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      $('#lfc-coupon-toggle').addEventListener('click', function () {
        var row = $('#lfc-coupon-row');
        row.hidden = !row.hidden;
        if (!row.hidden) $('#lfc-coupon-input').focus();
      });
      $('#lfc-coupon-apply').addEventListener('click', function () {
        var v = ($('#lfc-coupon-input').value || '').trim().toUpperCase();
        self.coupon = v;
        var note = $('#lfc-coupon-note');
        note.hidden = !v;
        note.textContent = v ? ('code ' + v + ' will apply at checkout ✦') : '';
      });
      $('#lfc-checkout-btn').addEventListener('click', function () {
        var url = '/checkout' + (self.coupon ? ('?discount=' + encodeURIComponent(self.coupon)) : '');
        window.location.href = url;
      });
    },

    open: function () {
      $('#lf-cart-drawer').classList.add('lfc-on');
      $('#lf-cart-overlay').classList.add('lfc-on');
      $('#lf-cart-drawer').setAttribute('aria-hidden', 'false');
      $('#lf-cart-drawer').inert = false;
      document.documentElement.style.overflow = 'hidden';
      this.opened = true;
    },
    close: function () {
      $('#lf-cart-drawer').classList.remove('lfc-on');
      $('#lf-cart-overlay').classList.remove('lfc-on');
      $('#lf-cart-drawer').setAttribute('aria-hidden', 'true');
      $('#lf-cart-drawer').inert = true;
      document.documentElement.style.overflow = '';
      this.opened = false;
    },

    /* ---------------- render ---------------- */
    render: function () {
      if (!this.cart) return;
      var cart = this.cart;
      var gift = this.giftLine();
      var sub = this.tierSubtotal();
      var lvl = this.level();

      /* level-up celebration */
      if (this.prevLevel !== -1 && lvl > this.prevLevel) {
        var tier = TIERS[lvl - 1];
        this.stamp('LVL ' + lvl + ' UNLOCKED');
        this.confetti();
        this.toast(tier.unlockMsg);
      }
      this.prevLevel = lvl;

      /* guard: a cart of only add-ons / gifts / the retired discreet-shipping line can't check out — clear them */
      var NONP = CFG.nonProduct || [];
      var real = cart.items.filter(function (i) { return NONP.indexOf(i.handle) === -1; });
      if (cart.item_count > 0 && real.length === 0 && !this._clearingOrphans) {
        this._clearingOrphans = true;
        var upd = {}; cart.items.forEach(function (i) { upd[i.key] = 0; });
        var selfC = this;
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) })
          .then(function () { selfC._clearingOrphans = false; return selfC.refresh ? selfC.refresh() : null; })
          .catch(function () { selfC._clearingOrphans = false; });
      }
      var ck = document.getElementById('lfc-checkout-btn'); if (ck) ck.disabled = real.length === 0;
      this.renderXP(sub, lvl);
      this.renderItems(cart, gift);
      this.renderNudge(sub, lvl);
      this.renderGift(lvl, gift);
      this.renderDrops();
      this.renderAddons();
      this.renderFooter(sub, lvl, gift);
      this.updateHeaderBadge(cart, gift);

      var empty = cart.item_count === 0;
      $('#lfc-empty').hidden = !empty;
      $('#lfc-items').style.display = empty ? 'none' : '';
      $('#lfc-nudge').style.display = empty ? 'none' : '';
      $('#lfc-gift').style.display = empty ? 'none' : '';
      $('#lfc-drops').style.display = empty ? 'none' : '';
      $('#lfc-addons').style.display = empty ? 'none' : '';
      $('#lfc-head-count').textContent = empty ? '' :
        (cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
    },

    renderXP: function (sub, lvl) {
      /* nodes are EVENLY spaced (one column per level) so labels never collide,
         regardless of how close the dollar thresholds are. Each node sits at the
         center of its 1/n column; the fill maps piecewise so it reaches a node
         exactly when that tier is hit. */
      var n = TIERS.length;
      var centerOf = function (i) { return ((i + 0.5) / n) * 100; };

      var fill = 0;
      for (var s = 0; s < n; s++) {
        var lo = s === 0 ? 0 : TIERS[s - 1].amount;
        var hi = TIERS[s].amount;
        if (sub < hi) {
          var segStart = s === 0 ? 0 : centerOf(s - 1);
          fill = segStart + ((sub - lo) / (hi - lo)) * (centerOf(s) - segStart);
          break;
        }
        fill = centerOf(s);
      }
      if (n && sub >= TIERS[n - 1].amount) fill = 100;
      $('#lfc-xp-fill').style.width = Math.max(0, Math.min(100, fill)) + '%';

      var nodes = $('#lfc-xp-nodes');
      nodes.innerHTML = TIERS.map(function (t, i) {
        var hit = sub >= t.amount;
        return '<div class="lfc-xp-node' + (hit ? ' lfc-hit' : '') + '" style="left:' + centerOf(i) + '%">' +
          '<div class="lfc-xp-node-dot">' + t.icon + '</div>' +
          '<div class="lfc-xp-node-label"><span class="lfc-xp-lvl">LVL ' + (i + 1) + '</span>' + t.label + '</div>' +
          '</div>';
      }).join('');

      var msgs = [];
      TIERS.forEach(function (t, i) {
        if (sub >= t.amount) {
          msgs.push('<div class="lfc-xp-msg">🎉 <b>LVL ' + (i + 1) + '</b> — ' + t.unlockMsg.toLowerCase() + '</div>');
        }
      });
      var next = TIERS.find(function (t) { return sub < t.amount; });
      if (next) {
        var gap = next.amount - sub;
        msgs.push('<div class="lfc-xp-msg">👉 add <span class="lfc-gap-amt">' + money(gap) +
          '</span> to hit <b>LVL ' + (TIERS.indexOf(next) + 1) + ' · ' + next.label + '</b></div>');
      } else if (TIERS.length) {
        msgs.push('<div class="lfc-xp-msg"><b>MAX LEVEL.</b> ur fit is fully buffed ✦</div>');
      }
      $('#lfc-xp-msgs').innerHTML = msgs.join('');
    },

    renderItems: function (cart, gift) {
      var self = this;
      var ul = $('#lfc-items');
      ul.innerHTML = cart.items.map(function (it, idx) {
        var isGift = gift && it.key === gift.key;
        var variantTitle = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var priceHtml = isGift
          ? '<span class="lfc-was">' + money(it.final_line_price) + '</span><span class="lfc-free">FREE</span>'
          : money(it.final_line_price);
        var qtyHtml = isGift
          ? '<span class="lfc-gift-badge">free gift ♡</span>'
          : '<div class="lfc-qty">' +
              '<button data-lfc-qty="-1" data-line="' + it.key + '" data-q="' + it.quantity + '" aria-label="Decrease">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-lfc-qty="1" data-line="' + it.key + '" data-q="' + it.quantity + '" aria-label="Increase">+</button>' +
            '</div>';
        return '<li class="lfc-item">' +
          '<img class="lfc-item-img" src="' + (it.image || '') + '" alt="" loading="lazy">' +
          '<div class="lfc-item-main">' +
            '<div class="lfc-item-title">' + it.product_title.split('|')[0].trim() + '</div>' +
            (variantTitle ? '<div class="lfc-item-variant">' + variantTitle + '</div>' : '') +
            '<div class="lfc-item-price">' + priceHtml + '</div>' +
          '</div>' +
          '<div class="lfc-item-side">' +
            '<button class="lfc-item-remove" data-lfc-remove="' + it.key + '" aria-label="Remove">🗑</button>' +
            qtyHtml +
          '</div>' +
        '</li>';
      }).join('');

      ul.querySelectorAll('[data-lfc-remove]').forEach(function (b) {
        b.addEventListener('click', function () { self.changeQty(b.dataset.lfcRemove, 0); });
      });
      ul.querySelectorAll('[data-lfc-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = parseInt(b.dataset.q, 10) + parseInt(b.dataset.lfcQty, 10);
          self.changeQty(b.dataset.line, Math.max(0, q));
        });
      });
    },

    /* suggest a real product that closes the gap to the next tier */
    renderNudge: function (sub, lvl) {
      var box = $('#lfc-nudge');
      var next = TIERS.find(function (t) { return sub < t.amount; });
      if (!next || !DROPS.length || !this.cart || this.cart.item_count === 0) { box.innerHTML = ''; return; }
      var gap = next.amount - sub;
      var inCart = this.cart.items.map(function (i) { return i.handle; });
      var self0 = this;
      /* 2026-09-23: same-design garments first (from /products/<h>?view=designsibs), then Rare Drops */
      this._sibs = this._sibs || {};
      var NONP0 = CFG.nonProduct || [];
      this.cart.items.forEach(function (i) {
        if (NONP0.indexOf(i.handle) !== -1 || self0._sibs[i.handle]) return;
        self0._sibs[i.handle] = 'loading';
        fetch('/products/' + i.handle + '?view=designsibs').then(function (r) { return r.text(); })
          .then(function (t) { try { self0._sibs[i.handle] = JSON.parse(t); } catch (e) { self0._sibs[i.handle] = []; } self0.renderNudge(self0._lastSub, self0._lastLvl); })
          .catch(function () { self0._sibs[i.handle] = []; });
      });
      this._lastSub = sub; this._lastLvl = lvl;
      var sibs = [];
      Object.keys(this._sibs).forEach(function (h) { if (Array.isArray(self0._sibs[h]) && inCart.indexOf(h) !== -1) sibs = sibs.concat(self0._sibs[h]); });
      sibs = sibs.filter(function (d, ix, arr) { return inCart.indexOf(d.handle) === -1 && arr.findIndex(function (x) { return x.handle === d.handle; }) === ix; });
      var drops = DROPS.filter(function (d) { return inCart.indexOf(d.handle) === -1; });
      if (!sibs.length && !drops.length) { box.innerHTML = ''; return; }
      var closeCheap = function (list) { return list.filter(function (d) { return d.price >= gap; }).sort(function (a, b) { return a.price - b.price; })[0]; };
      var priciest = function (list) { return list.slice().sort(function (a, b) { return b.price - a.price; })[0]; };
      /* cheapest same-design piece that closes the gap → cheapest drop that closes it → priciest same-design → priciest drop */
      var pick = closeCheap(sibs) || closeCheap(drops) || priciest(sibs) || priciest(drops);
      var closes = pick.price >= gap;
      var lvlNum = TIERS.indexOf(next) + 1;

      box.innerHTML = '<div class="lfc-nudge-card">' +
        '<img src="' + pick.image + '" alt="">' +
        '<div class="lfc-nudge-copy">' + (pick.sib ? '<span class="lfc-nudge-tag">same design ✦</span><br>' : '') + '<b>' + pick.title + '</b> ' +
          (closes ? ('gets u to <b>LVL ' + lvlNum + '</b> →') : ('adds +' + money(pick.price) + ' toward <b>LVL ' + lvlNum + '</b>')) +
        '</div>' +
        '<button class="lfc-nudge-add" data-vid="' + pick.id + '">+ ' + money(pick.price) + '</button>' +
      '</div>';
      var self = this;
      box.querySelector('.lfc-nudge-add').addEventListener('click', function (e) {
        self.addVariant(parseInt(e.currentTarget.dataset.vid, 10));
      });
    },

    renderGift: function (lvl, gift) {
      var box = $('#lfc-gift');
      if (!this.reached('gift') || !GIFTS.length) { box.innerHTML = ''; return; }
      var self = this;
      var pickedId = gift ? gift.variant_id : this.pickedGiftId;
      /* copy reflects how many gifts exist: don't say "choose" when there's only one */
      var multi = GIFTS.length > 1;
      box.innerHTML = '<div class="lfc-gift-wrap">' +
        '<div class="lfc-gift-title">' + (multi ? 'choose ur drop 🎁' : 'ur free gift 🎁') + '</div>' +
        '<div class="lfc-gift-sub">' + (multi ? 'free gift unlocked — pick ur fave ♡' : 'unlocked — on us, added to ur fit ♡') + '</div>' +
        '<div class="lfc-gift-options">' +
        GIFTS.map(function (g) {
          return '<div class="lfc-gift-opt' + (g.id === pickedId ? ' lfc-picked' : '') + '" data-vid="' + g.id + '" role="button" tabindex="0">' +
            '<img src="' + g.image + '" alt="">' +
            '<div class="lfc-gift-opt-name">' + g.title + '</div>' +
            '<div class="lfc-gift-opt-price"><s>' + money(g.price) + '</s><b>FREE</b></div>' +
          '</div>';
        }).join('') +
        '</div></div>';
      box.querySelectorAll('.lfc-gift-opt').forEach(function (el) {
        el.addEventListener('click', function () { self.swapGift(parseInt(el.dataset.vid, 10)); });
      });
    },

    renderDrops: function () {
      var box = $('#lfc-drops');
      if (!DROPS.length || !this.cart || this.cart.item_count === 0) { box.innerHTML = ''; return; }
      // Exclude anything already in the cart (so once a shopper equips a drop it's
      // never shown again — the next available drop in its tier takes its slot) and
      // the free-gift product.
      var inCart = this.cart.items.map(function (i) { return i.handle; });
      var avail = DROPS.filter(function (d) {
        return inCart.indexOf(d.handle) === -1 && GIFT_HANDLES.indexOf(d.handle) === -1;
      });
      // Show exactly one common + one rare — common first, rare second.
      var commons = avail.filter(function (d) { return d.rarity !== 'rare'; });
      var rares   = avail.filter(function (d) { return d.rarity === 'rare'; });
      var picks = [];
      if (commons.length) picks.push(commons[0]);
      if (rares.length)   picks.push(rares[0]);
      // If one tier is exhausted, backfill from the other so two cards still show.
      if (picks.length < 2) {
        var extra = avail.filter(function (d) { return picks.indexOf(d) === -1; });
        if (extra.length) picks.push(extra[0]);
      }
      if (!picks.length) { box.innerHTML = ''; return; }
      var self = this;
      box.innerHTML = '<div class="lfc-section-head">rare drops 4 ur fit</div>' +
        '<div class="lfc-drop-grid">' +
        picks.map(function (d) {
          return '<div class="lfc-drop-card">' +
            '<span class="lfc-drop-stamp ' + d.rarity + '">' + d.rarity.toUpperCase() + '</span>' +
            '<img src="' + d.image + '" alt="" loading="lazy">' +
            '<div class="lfc-drop-name">' + d.title + '</div>' +
            '<div class="lfc-drop-price">' + money(d.price) + '</div>' +
            '<button class="lfc-drop-add" data-vid="' + d.id + '">equip ✦</button>' +
          '</div>';
        }).join('') +
        '</div>';
      box.querySelectorAll('.lfc-drop-add').forEach(function (b) {
        b.addEventListener('click', function () { self.addVariant(parseInt(b.dataset.vid, 10)); });
      });
    },

    /* 2026-09-23 (Steven): colour-MATCHED add-ons. One pick per slot (pasties · choker · leg), in the cart's
       dominant colour (weighted by line price). Colour per item: category colour metafield > title > tags,
       fetched once per handle from /products/<h>?view=lfcolour. Accessories already in the cart count too
       (blue socks → blue choker + blue garter). Pink is the fallback. */
    renderAddons: function () {
      var box = $('#lfc-addons');
      if (!ADDONS.length || !this.cart || this.cart.item_count === 0) { box.innerHTML = ''; return; }
      var self = this;
      this._col = this._col || {};
      var inCart = {};
      this.cart.items.forEach(function (i) { inCart[i.handle] = i.key; });
      var addonBy = {};
      ADDONS.forEach(function (a) { addonBy[a.handle] = a; });
      var weights = {}, pending = false;
      this.cart.items.forEach(function (i) {
        if (GIFT_HANDLES.indexOf(i.handle) !== -1 || ADDON_SKIP.indexOf(i.handle) !== -1) return;
        var c = addonBy[i.handle] ? addonBy[i.handle].colour : null;
        if (!c) {
          var f = self._col[i.handle];
          if (f && typeof f === 'object') c = colourOf(f.c) || colourOf(f.t) || colourOf(i.handle.replace(/-/g, ' ')) ||
            colourOf(String(f.g || '').replace(/(^|\s)meta-\S+/g, ' '));   /* size-chart tags name colours that aren't the product's */
          else {
            pending = true;
            if (!f) {
              self._col[i.handle] = 'loading';
              fetch('/products/' + i.handle + '?view=lfcolour').then(function (r) { return r.json(); })
                .then(function (d) { self._col[i.handle] = d || {}; self.renderAddons(); })
                .catch(function () { self._col[i.handle] = {}; });
            }
          }
        }
        if (c) weights[c] = (weights[c] || 0) + i.final_line_price;
      });
      if (pending) { box.innerHTML = ''; return; }   /* wait for colours (~100ms) — no pink→white flicker */
      var colour = 'pink', best = 0;
      Object.keys(weights).forEach(function (k) { if (weights[k] > best) { best = weights[k]; colour = k; } });
      /* leg slot: a GARTER first — socks already in the cart still get a matching garter offered;
         socks only fill the slot when there's no garter in that colour */
      var pick = function (opts) {
        return opts.filter(function (a) { return inCart[a.handle]; })[0] ||
          opts.filter(function (a) { return a.colour === colour; })[0];
      };
      var picks = ['pasties', 'choker', 'leg'].map(function (slot) {
        var opts = ADDONS.filter(function (a) { return a.slot === slot; });
        var pinkFallback = opts.filter(function (a) { return a.colour === 'pink'; })[0];
        if (slot !== 'leg') return pick(opts) || pinkFallback;
        var garters = opts.filter(function (a) { return /garter/.test(a.handle); });
        var socks = opts.filter(function (a) { return !/garter/.test(a.handle); });
        return pick(garters) || pick(socks) || pinkFallback;
      }).filter(Boolean);
      if (!picks.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<div class="lfc-section-head">match the lewk ✦</div>' +
        '<div class="lfc-addon-sub">picked in ' + colour + ' to go with ur cart</div>' +
        '<div class="lfc-addon-row">' +
        picks.map(function (a) {
          var picked = !!inCart[a.handle];
          return '<button class="lfc-addon-pill' + (picked ? ' lfc-picked' : '') + '" data-handle="' + a.handle + '" data-vid="' + a.id + '">' +
            '<span class="lfc-addon-check">' + (picked ? '✓' : '') + '</span>' +
            (a.image ? '<img src="' + a.image + '" alt="" loading="lazy">' : '') +
            a.title + ' <span class="lfc-addon-price">+' + money(a.price) + '</span>' +
          '</button>';
        }).join('') +
        '</div>';
      box.querySelectorAll('.lfc-addon-pill').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = inCart[b.dataset.handle];
          if (key) self.changeQty(key, 0);
          else self.addVariant(parseInt(b.dataset.vid, 10));
        });
      });
    },

    renderFooter: function (sub, lvl, gift) {
      this._footArgs = arguments;
      var savings = gift ? gift.final_line_price : 0;
      var row = $('#lfc-savings-row');
      var offUnlocked = this.reached('off');
      row.hidden = savings === 0 && !offUnlocked;
      $('#lfc-savings-amount').textContent = savings ? ('−' + money(savings)) : '';
      if (offUnlocked) {
        row.hidden = false;
        $('#lfc-savings-amount').textContent =
          (savings ? '−' + money(savings) + ' · ' : '') + '20% off applies at checkout ✦';
      }
      $('#lfc-subtotal-amount').textContent = money(sub);
      /* 2026-09-23 checkout audit: say shipping + discreet + US duties BEFORE checkout. Rewards count products only — never duties. */
      var shipTier = TIERS.find(function (t) { return t.key === 'ship'; });
      var lines = [];
      if (this.reached('ship')) lines.push('<span class="lfc-fn-ship">free shipping unlocked ✦</span>');
      else if (shipTier) lines.push('<span class="lfc-fn-ship">free shipping at ' + money(shipTier.amount) + ' · u\'re ' + money(shipTier.amount - sub) + ' away</span>');
      lines.push('<span>ships discreet · plain packaging, always 🤫</span>');
      if (CFG.country === 'US') lines.push('<span>ships from Canada · US duties calculated at checkout (rewards count products only, never duties)</span>');
      lines.push('<span>taxes calculated at checkout</span>');
      /* 2026-10-18 (Steven): SMALL BATCH note when any item is tagged small-batch (Eric drop-ship; 10-30 wording: MADE TO ORDER, ships in 2-3 weeks,
         whole order ships together). Tags come from /products/<h>?view=lfcolour (field g), cached per handle. */
      var self = this, sb = false;
      this._sb = this._sb || {};
      ((this.cart && this.cart.items) || []).forEach(function (i) {
        var v = self._sb[i.handle];
        if (v === true) sb = true;
        else if (v === undefined) {
          self._sb[i.handle] = 'loading';
          fetch('/products/' + i.handle + '?view=lfcolour').then(function (r) { return r.json(); })
            .then(function (d) {
              self._sb[i.handle] = (' ' + String((d && d.g) || '') + ' ').indexOf(' small-batch ') !== -1;
              if (self._sb[i.handle] && self._footArgs) self.renderFooter.apply(self, self._footArgs);
            })
            .catch(function () { self._sb[i.handle] = false; });
        }
      });
      if (sb) lines.unshift('<span class="lfc-fn-sb"><strong>MADE TO ORDER:</strong> something in your cart is custom made to order and ships in 2-3 weeks. Your whole order ships together in one package.</span>');
      $('#lfc-foot-note').innerHTML = lines.join('');
    },

    updateHeaderBadge: function (cart, gift) {
      var visible = cart.item_count - (gift ? gift.quantity : 0);
      document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) {
        el.textContent = visible;
      });
      var bubble = document.querySelector('.cart-count-bubble');
      if (bubble) bubble.style.display = visible > 0 ? '' : 'none';
    },

    /* ---------------- delight ---------------- */
    toast: function (msg) {
      var t = $('#lfc-toast');
      $('#lfc-toast-msg').textContent = msg;
      t.classList.add('lfc-on');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(function () { t.classList.remove('lfc-on'); }, 2600);
    },

    stamp: function (text) {
      var s = $('#lfc-stamp');
      $('#lfc-stamp-text').textContent = text;
      s.classList.remove('lfc-on');
      void s.offsetWidth; /* restart animation */
      s.classList.add('lfc-on');
      setTimeout(function () { s.classList.remove('lfc-on'); }, 1000);
    },

    confetti: function () {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var host = $('#lfc-confetti');
      var glyphs = ['✦', '♡', '★', '✧', '♥'];
      var colors = ['#ffd6e0', '#ff97ad', '#e8457a', '#c93460'];
      for (var i = 0; i < 26; i++) {
        var c = document.createElement('span');
        c.className = 'lfc-confetto';
        c.textContent = glyphs[Math.floor(Math.random() * glyphs.length)];
        c.style.left = Math.random() * 100 + 'vw';
        c.style.color = colors[Math.floor(Math.random() * colors.length)];
        c.style.fontSize = (12 + Math.random() * 14) + 'px';
        c.style.animationDuration = (1.4 + Math.random() * 1.4) + 's';
        c.style.animationDelay = (Math.random() * 0.4) + 's';
        host.appendChild(c);
      }
      setTimeout(function () { host.innerHTML = ''; }, 3400);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { LFCart.init(); });
  } else {
    LFCart.init();
  }
  window.LFCart = LFCart;
})();
